export function getPossibleTypesFromFragmentTypes(fragmentTypes) {
  // eslint-disable-next-line no-underscore-dangle
  return fragmentTypes.__schema.types.reduce((acc, superType) => {
    return {
      ...acc,
      [superType.name]: superType.possibleTypes.map((subType) => subType.name),
    };
  }, {});
}
